/**
 * Returns the email if present, otherwise the phone number, otherwise an empty string.
 * Use when displaying a single contact identifier for a member (e.g. in a list row or avatar tooltip).
 *
 * Callers pass the two fields directly so this works regardless of DTO field naming
 * (`email` vs `emailAddress`, `phoneE164` vs `memberPhoneE164`).
 */
export const displayContact = (
	email: string | null | undefined,
	phone: string | null | undefined,
): string => {
	if (email) return email;
	return phone ?? "";
};
